import React from 'react'
import { Text } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './SummaryExercise.css'

const SummaryExercise = props => {
  return (
    <div className="Summary-exercise">
      <div className="Nav-bar">
        <Text>Opdrachten</Text>
        <a href={props.link} target="_blank" rel="noopener noreferrer">Download als .pdf</a>
      </div>
      <div>
        {props.children}
      </div>
    </div>
  )
}

export default SummaryExercise
